const PRICE = 700
const PRICE_FULL = 1000
const INSTALLMENT_PRICE = 160
const INSTALLMENT_PRICE_FULL = 220
const INSTALLMENTS = 5
const START_DATE = 'Sep 28th, 2026'
const CLOSE_DATE = 'Oct 26th, 2026'
const CLOSE_DEADLINE = new Date('2026-10-05T00:00:00Z')
const EARLY_BIRD_DEADLINE = new Date('2026-09-03T00:00:00Z')
const EARLY_BIRD_DATE = 'September 1st, 2026'
const SINGLE_PAYMENT_ID = 'prsls-sept-2026'
const INSTALLMENT_ID = 'prsls-sept-2026-instalments'
const BE_URL = 'https://ipwkqgl8cg.execute-api.eu-west-1.amazonaws.com/dev'
const NEWSLETTER_DISCOUNT = 15
const WAITLIST_FORM_UID = '2e1c6be44e'

const TEAM_PLANS = [
  { seats: 3, discount: 0.15, optionId: '1YrJ_WfpknHXCqAXiAlwHA%3D%3D' },
  { seats: 4, discount: 0.15, optionId: 'bokNM2H6EPLn6FJB3V2ECw%3D%3D' },
  { seats: 5, discount: 0.20, optionId: 'Rvf4EI8E4ifJc1WVomrw3A%3D%3D' },
  { seats: 6, discount: 0.20, optionId: 'nb0AhyCQrDW1k3o_HR24DQ%3D%3D' },
  { seats: 7, discount: 0.20, optionId: 'Nm1nDtbiXeauLfgeAaf_Qg%3D%3D' },
  { seats: 8, discount: 0.20, optionId: '11_3MOtVmkCdQ9SJrE5-uQ%3D%3D' },
  { seats: 9, discount: 0.20, optionId: 'OHEWjikROBfHGlIeMdREaQ%3D%3D' },
  { seats: 10, discount: 0.25, optionId: 'waqplriutpTJsJ7e4_LJrw%3D%3D' }
]

export {
  PRICE,
  PRICE_FULL,
  INSTALLMENT_PRICE,
  INSTALLMENT_PRICE_FULL,
  INSTALLMENTS,
  START_DATE,
  CLOSE_DATE,
  CLOSE_DEADLINE,
  EARLY_BIRD_DEADLINE,
  EARLY_BIRD_DATE,
  SINGLE_PAYMENT_ID,
  INSTALLMENT_ID,
  BE_URL,
  NEWSLETTER_DISCOUNT,
  WAITLIST_FORM_UID,
  TEAM_PLANS
}
